export default [
  {
    path: '/repositories',
    name: 'repository-list',
    component: () => import('@/views/repositories/Index.vue'),
    meta: {
      pageTitle: 'Dépôts logistiques',
      description: 'Gestion centralisée des dépôts logistiques, visualisation, recherche, filtrage et accès rapide aux informations clés. Accessibilité renforcée pour tous les utilisateurs.',
      accessibility: {
        ariaLabel: 'Liste des dépôts logistiques',
        help: 'Consultez, filtrez et gérez les dépôts logistiques. Utilisez la recherche pour trouver un dépôt spécifique. Les actions sont accessibles via le clavier et les lecteurs d’écran.',
      },
      breadcrumb: [
        {
          text: 'Dépôts logistiques',
          active: true,
        },
      ],
    },
  },
  {
    path: '/repositories/add',
    name: 'repository-add',
    component: () => import('@/views/repositories/Create.vue'),
    meta: {
      pageTitle: 'Ajouter un dépôt logistique',
      description: 'Formulaire accessible pour l’ajout d’un nouveau dépôt logistique. Tous les champs obligatoires sont clairement indiqués et accompagnés d’aides contextuelles.',
      accessibility: {
        ariaLabel: 'Formulaire d’ajout de dépôt logistique',
        help: 'Remplissez les informations requises pour créer un nouveau dépôt. Les champs obligatoires sont signalés. Utilisez Tab pour naviguer et valider le formulaire.',
      },
      breadcrumb: [
        {
          text: 'Dépôts logistiques',
          to: { name: 'repository-list' },
        },
        {
          text: 'Ajouter',
          active: true,
        },
      ],
    },
  },
  {
    path: '/repositories/edit/:id',
    name: 'repository-edit',
    component: () => import('@/views/repositories/Edit.vue'),
    meta: {
      pageTitle: 'Modifier un dépôt logistique',
      description: 'Modification des informations d’un dépôt logistique existant. Accessibilité optimisée et validation des champs en temps réel.',
      accessibility: {
        ariaLabel: 'Formulaire de modification de dépôt logistique',
        help: 'Modifiez les informations du dépôt sélectionné. Les champs sont validés automatiquement. Utilisez Tab pour naviguer et valider.',
      },
      breadcrumb: [
        {
          text: 'Dépôts logistiques',
          to: { name: 'repository-list' },
        },
        {
          text: 'Modifier',
          active: true,
        },
      ],
    },
  },
  {
    path: '/repositories/show/:id',
    name: 'repository-show',
    component: () => import('@/views/repositories/Show.vue'),
    meta: {
      pageTitle: 'Détails du dépôt logistique',
      description: 'Visualisation détaillée d’un dépôt logistique, incluant les informations principales, les indicateurs de performance et l’accessibilité pour tous les profils.',
      accessibility: {
        ariaLabel: 'Détails du dépôt logistique',
        help: 'Consultez toutes les informations du dépôt, les indicateurs et l’historique. Les actions sont accessibles via le clavier et les lecteurs d’écran.',
      },
      breadcrumb: [
        {
          text: 'Dépôts logistiques',
          to: { name: 'repository-list' },
        },
        {
          text: 'Détails',
          active: true,
        },
      ],
    },
  },
]
